"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.getUrlsFromEndpoints = exports.createEndpointObjects = exports.defaultFailoverConfig = exports.isKeyPair = exports.formatBlockInfoResponse = exports.formatTransactionInfoResponse = exports.handlePostResponsePromisified = exports.callbackPromiseBuilder = void 0;
exports.getClientConfigFromSettings = getClientConfigFromSettings;
exports.getMerkleHashVersionFromDapp = getMerkleHashVersionFromDapp;
exports.validTxRid = validTxRid;
exports.nodeDiscovery = nodeDiscovery;
exports.getBlockchainApiUrls = getBlockchainApiUrls;
exports.convertToRellOperation = convertToRellOperation;
exports.getSerializedGTX = getSerializedGTX;
exports.getGTXFromBufferOrTransactionOrOperation = getGTXFromBufferOrTransactionOrOperation;
exports.formatRejectedTransactionFromResponse = formatRejectedTransactionFromResponse;
exports.getSystemClient = getSystemClient;
exports.getSystemAnchoringChain = getSystemAnchoringChain;
exports.awaitDappConfirmation = awaitDappConfirmation;
exports.awaitClusterAnchoringChainConfirmation = awaitClusterAnchoringChainConfirmation;
exports.handleDappConfirmations = handleDappConfirmations;
exports.handleSystemConfirmations = handleSystemConfirmations;
exports.getAnchoringClientAndSystemChainRid = getAnchoringClientAndSystemChainRid;
exports.getSystemAnchoringTransaction = getSystemAnchoringTransaction;
exports.setStatusPolling = setStatusPolling;
exports.setRetryTransactionPolling = setRetryTransactionPolling;
exports.linkPromiEvents = linkPromiEvents;
exports.handleGetResponse = handleGetResponse;
exports.handlePostResponse = handlePostResponse;
exports.getBlockchainRidFromIid = getBlockchainRidFromIid;
exports.convertToPrintable = convertToPrintable;
const buffer_1 = require("buffer");
const logger = __importStar(require("../logger"));
const errors_1 = require("./errors");
const gtxTool = __importStar(require("../gtx/gtx"));
const errors_2 = require("./errors");
const formatter_1 = require("../formatter");
const blockchainClient_1 = require("./blockchainClient");
const enums_1 = require("./enums");
const nodeManager_1 = require("./nodeManager");
const anchoringTransaction_1 = require("./validation/anchoringTransaction");
const error_1 = require("../ICCF/error");
const IccfProofTxMaterialBuilder_1 = require("../ICCF/IccfProofTxMaterialBuilder");
const utils_1 = require("../ICCF/utils");
const requests_1 = require("./validation/requests");
const encodeTransaction_1 = require("../utils/encodeTransaction");
const merkleHash_1 = require("./validation/merkleHash");
const requestWithFailoverStrategy_1 = require("./requestWithFailoverStrategy");
const constants_1 = require("../utils/constants");
const http_utils_1 = require("../utils/http-utils");
function getClientConfigFromSettings(settings) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const nodeUrlPoolToUse = yield getNodeUrlsFromSettings(settings);
        if (nodeUrlPoolToUse === null || nodeUrlPoolToUse.length === 0) {
            const id = (_b = (_a = settings.blockchainRid) !== null && _a !== void 0 ? _a : settings.blockchainIid) !== null && _b !== void 0 ? _b : "Unknown";
            throw new errors_2.BlockchainUrlUndefinedException(id);
        }
        const endpointPool = (0, exports.createEndpointObjects)(nodeUrlPoolToUse);
        const nodeManager = (0, nodeManager_1.createNodeManager)({
            nodeUrls: nodeUrlPoolToUse,
            useStickyNode: (_c = settings.useStickyNode) !== null && _c !== void 0 ? _c : false,
            unavailableDuration: (_d = settings.failOverConfig) === null || _d === void 0 ? void 0 : _d.unreachableDuration,
        });
        const blockchainRidToUse = yield (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (settings.blockchainRid) {
                return settings.blockchainRid;
            }
            if (settings.blockchainIid !== undefined) {
                return yield getBlockchainRidFromIid({
                    nodeManager,
                    endpointPool,
                    chainId: settings.blockchainIid,
                    merkleHashVersion: (_a = settings.merkleHashVersion) !== null && _a !== void 0 ? _a : constants_1.MERKLE_HASH_VERSIONS.UNSET,
                    connectTimeout: settings.connectTimeout,
                    responseTimeout: settings.responseTimeout,
                });
            }
            throw new errors_2.MissingBlockchainIdentifierError();
        }))();
        const directoryChainRid = yield (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (settings.directoryChainRid) {
                return settings.directoryChainRid;
            }
            const directoryChainIid = 0;
            return yield getBlockchainRidFromIid({
                nodeManager,
                endpointPool,
                chainId: directoryChainIid,
                merkleHashVersion: (_a = settings.merkleHashVersion) !== null && _a !== void 0 ? _a : constants_1.MERKLE_HASH_VERSIONS.UNSET,
                connectTimeout: settings.connectTimeout,
                responseTimeout: settings.responseTimeout,
            });
        }))();
        return Object.assign(Object.assign(Object.assign({ endpointPool, nodeManager: nodeManager }, (settings.blockedNodeUrlSubstrings !== undefined
            ? { blockedNodeUrlSubstrings: settings.blockedNodeUrlSubstrings }
            : {})), (settings.nodeUrlFilter !== undefined ? { nodeUrlFilter: settings.nodeUrlFilter } : {})), { blockchainRid: blockchainRidToUse, merkleHashVersion: (_e = settings.merkleHashVersion) !== null && _e !== void 0 ? _e : constants_1.MERKLE_HASH_VERSIONS.UNSET, dappStatusPolling: setStatusPolling(settings.dappStatusPolling), clusterAnchoringStatusPolling: setStatusPolling(settings.clusterAnchoringStatusPolling), systemAnchoringStatusPolling: setStatusPolling(settings.systemAnchoringStatusPolling), retryTransactionPolling: setRetryTransactionPolling(settings.retryTransactionPolling), failoverStrategy: ((_f = settings.failOverConfig) === null || _f === void 0 ? void 0 : _f.strategy) || exports.defaultFailoverConfig.strategy, attemptsPerEndpoint: ((_g = settings.failOverConfig) === null || _g === void 0 ? void 0 : _g.attemptsPerEndpoint) || exports.defaultFailoverConfig.attemptsPerEndpoint, attemptInterval: ((_h = settings.failOverConfig) === null || _h === void 0 ? void 0 : _h.attemptInterval) || exports.defaultFailoverConfig.attemptInterval, unreachableDuration: ((_j = settings.failOverConfig) === null || _j === void 0 ? void 0 : _j.unreachableDuration) || exports.defaultFailoverConfig.unreachableDuration, directoryChainRid: settings.directoryChainRid || directoryChainRid, connectTimeout: settings.connectTimeout, responseTimeout: settings.responseTimeout });
    });
}
function getMerkleHashVersionFromDapp(config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/config/${config.blockchainRid}/features`, config, undefined, false, (_a = config.connectTimeout) !== null && _a !== void 0 ? _a : config.responseTimeout);
            const validatedResponse = (0, merkleHash_1.validateMerkleHash)(response.rspBody);
            return validatedResponse.merkle_hash_version;
        }
        catch (error) {
            console.warn("MERKLE_HASH_WARNING: version not found or endpoint unreachable", error);
            return constants_1.MERKLE_HASH_VERSIONS.ONE;
        }
    });
}
function validTxRid(txRID) {
    if (txRID.length != 32) {
        const error = new errors_1.InvalidTxRidException(txRID);
        logger.error(error.toString());
        return false;
    }
    return true;
}
function nodeDiscovery(_a) {
    return __awaiter(this, arguments, void 0, function* ({ nodeManager, directoryEndpointPool, blockedNodeUrlSubstrings, nodeUrlFilter, failOverConfig, blockchainRid, blockchainIid, connectTimeout, responseTimeout, }) {
        if (directoryEndpointPool.length === 0) {
            throw new errors_2.DirectoryNodeUrlPoolException();
        }
        if (!blockchainRid && blockchainIid === undefined) {
            throw new errors_2.MissingBlockchainIdentifierError();
        }
        const directoryIid = 0;
        const directoryBRID = yield getBlockchainRidFromIid({
            nodeManager,
            endpointPool: directoryEndpointPool,
            chainId: directoryIid,
            failOverConfig,
            connectTimeout,
            responseTimeout,
        });
        const blockchainRidToUse = yield (() => __awaiter(this, void 0, void 0, function* () {
            if (blockchainRid) {
                return blockchainRid;
            }
            if (blockchainIid !== undefined) {
                return yield getBlockchainRidFromIid({
                    nodeManager,
                    endpointPool: directoryEndpointPool,
                    chainId: blockchainIid,
                    failOverConfig,
                    connectTimeout,
                    responseTimeout,
                });
            }
            throw new errors_2.MissingBlockchainIdentifierError();
        }))();
        const D1Client = yield (0, blockchainClient_1.createClient)({
            nodeUrlPool: (0, exports.getUrlsFromEndpoints)(directoryEndpointPool),
            blockchainRid: directoryBRID,
        });
        const discoveredNodes = yield getBlockchainApiUrls(D1Client, (0, formatter_1.ensureBuffer)(blockchainRidToUse));
        return applyNodeUrlFilters(discoveredNodes, {
            blockedNodeUrlSubstrings,
            nodeUrlFilter,
        }, "discoveredNodeUrlPool");
    });
}
function getBlockchainApiUrls(directoryClient, blockchainRid) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryObject = {
            name: "cm_get_blockchain_api_urls",
            args: { blockchain_rid: blockchainRid },
        };
        return yield directoryClient.query(queryObject);
    });
}
function convertToRellOperation(operations) {
    return operations.map(operation => {
        var _a;
        return {
            opName: operation.name,
            args: (_a = operation.args) !== null && _a !== void 0 ? _a : [],
        };
    });
}
function getSerializedGTX(gtx) {
    const gtxBytes = (0, encodeTransaction_1.encodeTransaction)(gtx);
    if (!buffer_1.Buffer.isBuffer(gtxBytes)) {
        throw new errors_1.SerializedTransactionFormatException();
    }
    return gtxBytes;
}
function getGTXFromBufferOrTransactionOrOperation(transaction, blockchainRid) {
    if (buffer_1.Buffer.isBuffer(transaction)) {
        return gtxTool.deserialize(transaction);
    }
    else if ("operations" in transaction) {
        return {
            blockchainRid: (0, formatter_1.ensureBuffer)(blockchainRid),
            operations: convertToRellOperation(transaction.operations),
            signers: transaction.signers,
            signatures: [],
        };
    }
    else if ("name" in transaction) {
        return {
            blockchainRid: (0, formatter_1.ensureBuffer)(blockchainRid),
            operations: convertToRellOperation([transaction]),
            signers: [],
            signatures: [],
        };
    }
    else {
        throw new errors_2.InvalidTransactionFormatException();
    }
}
const callbackPromiseBuilder = (reject, resolve, callback) => {
    return (error, result) => {
        var _a;
        if (error) {
            callback === null || callback === void 0 ? void 0 : callback(error, null);
            reject(error);
        }
        else {
            callback === null || callback === void 0 ? void 0 : callback(null, (_a = result) !== null && _a !== void 0 ? _a : null);
            resolve(result !== null && result !== void 0 ? result : null);
        }
    };
};
exports.callbackPromiseBuilder = callbackPromiseBuilder;
const handlePostResponsePromisified = (error, statusCode, rspBody) => {
    return new Promise((resolve, reject) => {
        handlePostResponse(error, statusCode, rspBody, _error => {
            if (_error) {
                reject(_error);
            }
            else {
                resolve();
            }
        });
    });
};
exports.handlePostResponsePromisified = handlePostResponsePromisified;
function ensureArray(input) {
    if (typeof input === "string") {
        return [input];
    }
    return input;
}
const formatTransactionInfoResponse = (transactionInfoResponse) => {
    return {
        blockRid: (0, formatter_1.toBuffer)(transactionInfoResponse.blockRID),
        blockHeight: transactionInfoResponse.blockHeight,
        blockHeader: (0, formatter_1.toBuffer)(transactionInfoResponse.blockHeader),
        witness: (0, formatter_1.toBuffer)(transactionInfoResponse.witness),
        timestamp: transactionInfoResponse.timestamp,
        txRid: (0, formatter_1.toBuffer)(transactionInfoResponse.txRID),
        txHash: (0, formatter_1.toBuffer)(transactionInfoResponse.txHash),
        txData: (0, formatter_1.toBuffer)(transactionInfoResponse.txData),
    };
};
exports.formatTransactionInfoResponse = formatTransactionInfoResponse;
const formatBlockInfoResponse = (blockInfoResponse) => {
    return {
        rid: (0, formatter_1.toBuffer)(blockInfoResponse.rid),
        prevBlockRid: (0, formatter_1.toBuffer)(blockInfoResponse.prevBlockRID),
        header: (0, formatter_1.toBuffer)(blockInfoResponse.header),
        transactions: blockInfoResponse.transactions.map(formatTransaction),
        height: blockInfoResponse.height,
        witness: (0, formatter_1.toBuffer)(blockInfoResponse.witness),
        witnesses: blockInfoResponse.witnesses.map(witness => {
            return (0, formatter_1.toBuffer)(witness);
        }),
        timestamp: blockInfoResponse.timestamp,
    };
};
exports.formatBlockInfoResponse = formatBlockInfoResponse;
const formatTransaction = (transaction) => {
    const formattedTransaction = {
        rid: (0, formatter_1.toBuffer)(transaction.rid),
        hash: (0, formatter_1.toBuffer)(transaction.hash),
    };
    if (transaction.data !== undefined) {
        formattedTransaction.data = (0, formatter_1.toBuffer)(transaction.data);
    }
    return formattedTransaction;
};
function formatRejectedTransactionFromResponse(rejectedTransactionResponse) {
    return {
        txRid: (0, formatter_1.toBuffer)(rejectedTransactionResponse.txRID),
        rejectReason: rejectedTransactionResponse.rejectReason,
        rejectTimestamp: rejectedTransactionResponse.rejectTimestamp,
    };
}
const isKeyPair = (keypair) => {
    return (typeof keypair === "object" &&
        keypair !== null &&
        "privKey" in keypair &&
        "pubKey" in keypair &&
        keypair.privKey instanceof buffer_1.Buffer &&
        keypair.pubKey instanceof buffer_1.Buffer);
};
exports.isKeyPair = isKeyPair;
function getNodeUrlsFromSettings(settings) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (settings.directoryNodeUrlPool) {
            const directoryNodeUrlsOrNull = applyNodeUrlFilters(ensureArray(settings.directoryNodeUrlPool), settings, "directoryNodeUrlPool");
            if (directoryNodeUrlsOrNull === null) {
                throw new errors_2.DirectoryNodeUrlPoolException();
            }
            const directoryNodeUrls = directoryNodeUrlsOrNull;
            // If directoryNodeUrlPool is provided, use nodeDiscovery
            const nodeManager = (0, nodeManager_1.createNodeManager)({
                nodeUrls: directoryNodeUrls,
                unavailableDuration: (_a = settings.failOverConfig) === null || _a === void 0 ? void 0 : _a.unreachableDuration,
            });
            const discoveredNodes = yield nodeDiscovery({
                nodeManager,
                directoryEndpointPool: (0, exports.createEndpointObjects)(directoryNodeUrls),
                blockedNodeUrlSubstrings: settings.blockedNodeUrlSubstrings,
                nodeUrlFilter: settings.nodeUrlFilter,
                failOverConfig: settings.failOverConfig,
                blockchainRid: settings.blockchainRid,
                blockchainIid: settings.blockchainIid,
                connectTimeout: settings.connectTimeout,
                responseTimeout: settings.responseTimeout,
            });
            return discoveredNodes;
        }
        else if (typeof settings.nodeUrlPool === "string") {
            // If nodeUrlPool is a string, convert it to an array
            return applyNodeUrlFilters([settings.nodeUrlPool], settings, "nodeUrlPool");
        }
        else if (Array.isArray(settings.nodeUrlPool)) {
            // If nodeUrlPool is already an array, use it as-is
            return applyNodeUrlFilters(settings.nodeUrlPool, settings, "nodeUrlPool");
        }
        else {
            // Default to an empty array if no valid configuration is provided
            return [];
        }
    });
}
function applyNodeUrlFilters(nodeUrls, settings, poolName) {
    var _a;
    if (nodeUrls === null) {
        return null;
    }
    const hasBlockedSubstringsFilter = Array.isArray(settings.blockedNodeUrlSubstrings) &&
        settings.blockedNodeUrlSubstrings.length > 0;
    const hasNodeUrlFilter = typeof settings.nodeUrlFilter === "function";
    if (!hasBlockedSubstringsFilter && !hasNodeUrlFilter) {
        return nodeUrls;
    }
    const blockedSubstrings = ((_a = settings.blockedNodeUrlSubstrings) !== null && _a !== void 0 ? _a : [])
        .map(substring => substring.toLowerCase())
        .filter(substring => substring.length > 0);
    const filteredNodeUrls = nodeUrls.filter(url => {
        const isBlockedBySubstring = blockedSubstrings.some(substring => url.toLowerCase().includes(substring));
        const passesCustomFilter = settings.nodeUrlFilter ? settings.nodeUrlFilter(url) : true;
        return !isBlockedBySubstring && passesCustomFilter;
    });
    if (filteredNodeUrls.length === 0) {
        throw new errors_2.FilteredNodeUrlPoolEmptyError(poolName);
    }
    return filteredNodeUrls;
}
function getSystemClient(directoryNodeUrlPool, directoryChainRid) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, blockchainClient_1.createClient)({
            directoryNodeUrlPool,
            blockchainRid: directoryChainRid,
        });
    });
}
function getSystemAnchoringChain(directoryClient) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const queryObject = {
                name: "cm_get_system_anchoring_chain",
            };
            const systemAnchoringChain = yield directoryClient.query(queryObject);
            if (!systemAnchoringChain) {
                throw new error_1.SystemChainException("Directory chain client must be provided.");
            }
            return systemAnchoringChain;
        }
        catch (error) {
            throw new error_1.SystemChainException(error.message);
        }
    });
}
exports.defaultFailoverConfig = {
    strategy: enums_1.FailoverStrategy.AbortOnError,
    attemptsPerEndpoint: 3,
    attemptInterval: 500,
    unreachableDuration: 30000,
};
const createEndpointObjects = (endpointPoolUrls) => {
    const endpoints = endpointPoolUrls.map(endpointUrl => {
        return { url: endpointUrl, whenAvailable: 0 };
    });
    return endpoints;
};
exports.createEndpointObjects = createEndpointObjects;
const getUrlsFromEndpoints = (endpointPool) => {
    return endpointPool.map(endpoint => endpoint.url);
};
exports.getUrlsFromEndpoints = getUrlsFromEndpoints;
function awaitDappConfirmation(txRID, dappStatusPolling, getTransactionStatus) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let lastKnownResult = null;
        for (let i = 0; i < dappStatusPolling.count; i++) {
            lastKnownResult = yield getTransactionStatus(txRID);
            if (lastKnownResult.status === enums_1.ResponseStatus.Confirmed) {
                return lastKnownResult;
            }
            else if (lastKnownResult.status === enums_1.ResponseStatus.Rejected) {
                throw new errors_1.TxRejectedError((_a = lastKnownResult.rejectReason) !== null && _a !== void 0 ? _a : "");
            }
            yield (0, exports.sleep)(dappStatusPolling.interval);
        }
        throw new Error(`Retry count exceeded. Confirmation not received. Last transaction status: ${lastKnownResult === null || lastKnownResult === void 0 ? void 0 : lastKnownResult.status}`);
    });
}
function awaitClusterAnchoringChainConfirmation(txRID, clusterAnchoringStatusPolling, getClusterAnchoringTransactionConfirmation) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let clusterAnchoringConfirmation;
        for (let i = 0; i < clusterAnchoringStatusPolling.count; i++) {
            clusterAnchoringConfirmation = yield getClusterAnchoringTransactionConfirmation(txRID);
            const anchoringTransactionValidaiton = anchoringTransaction_1.AnchoringTransactionSchema.safeParse(clusterAnchoringConfirmation);
            if (anchoringTransactionValidaiton.success) {
                return {
                    status: enums_1.AnchoringStatus.ClusterAnchored,
                    clusterAnchoredTx: anchoringTransactionValidaiton.data,
                };
            }
            else if (!anchoringTransactionValidaiton.success) {
                throw new errors_1.TxRejectedError((_a = enums_1.AnchoringStatus.FailedAnchoring) !== null && _a !== void 0 ? _a : "");
            }
            yield (0, exports.sleep)(clusterAnchoringStatusPolling.interval);
        }
        // TS issue. This could be fixed by implementing new retry strategy
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        return clusterAnchoringConfirmation;
    });
}
function handleDappConfirmations(transactionRid, doStatusPolling, confirmationLevel, promiEvent, dappStatusPolling, getTransactionStatus, client) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const transactionReceipt = {
            status: enums_1.ResponseStatus.Pending,
            statusCode: null,
            transactionRid: transactionRid,
            node: (_a = client.config.nodeManager.lastUsedNode) === null || _a === void 0 ? void 0 : _a.url,
        };
        promiEvent.emit(enums_1.TransactionEvent.DappReceived, transactionReceipt);
        if (doStatusPolling === false || confirmationLevel === enums_1.ChainConfirmationLevel.None) {
            return transactionReceipt;
        }
        const dappConfirmationStatus = yield awaitDappConfirmation(transactionRid, dappStatusPolling, getTransactionStatus);
        transactionReceipt.statusCode = dappConfirmationStatus.statusCode;
        transactionReceipt.status = dappConfirmationStatus.status;
        transactionReceipt.node = (_b = client.config.nodeManager.lastUsedNode) === null || _b === void 0 ? void 0 : _b.url;
        promiEvent.emit(enums_1.TransactionEvent.DappConfirmed, transactionReceipt);
        if (confirmationLevel === enums_1.ChainConfirmationLevel.Dapp) {
            return transactionReceipt;
        }
        return transactionReceipt;
    });
}
function handleSystemConfirmations(transactionReceipt, confirmationLevel, promiEvent, statusPollingConfig, anchoringClient, systemAnchoringChainBrid, getClusterAnchoringTransactionConfirmation, getSystemAnchoringTransactionConfirmation) {
    return __awaiter(this, void 0, void 0, function* () {
        const clusterAnchoringChainConfirmation = yield awaitClusterAnchoringChainConfirmation(transactionReceipt.transactionRid, statusPollingConfig.clusterAnchoringStatusPolling, getClusterAnchoringTransactionConfirmation);
        transactionReceipt.status = clusterAnchoringChainConfirmation.status;
        transactionReceipt.clusterAnchoredTx = clusterAnchoringChainConfirmation.clusterAnchoredTx;
        transactionReceipt.clusterAnchoringClientBrid = anchoringClient.config.blockchainRid;
        promiEvent.emit(enums_1.TransactionEvent.ClusterAnchoringConfirmation, transactionReceipt);
        if (confirmationLevel === enums_1.ChainConfirmationLevel.ClusterAnchoring) {
            return transactionReceipt;
        }
        const systemAnchoringConfirmation = yield getSystemAnchoringTransactionConfirmation(clusterAnchoringChainConfirmation.clusterAnchoredTx.txRid, anchoringClient, systemAnchoringChainBrid);
        if (!systemAnchoringConfirmation) {
            return transactionReceipt;
        }
        transactionReceipt.status = enums_1.AnchoringStatus.SystemAnchored;
        transactionReceipt.systemAnchoredTx = systemAnchoringConfirmation;
        transactionReceipt.systemAnchoringClientBrid = systemAnchoringChainBrid;
        promiEvent.emit(enums_1.TransactionEvent.SystemAnchoringConfirmation, transactionReceipt);
        if (confirmationLevel === enums_1.ChainConfirmationLevel.SystemAnchoring) {
            return transactionReceipt;
        }
        return transactionReceipt;
    });
}
function getAnchoringClientAndSystemChainRid(client) {
    return __awaiter(this, void 0, void 0, function* () {
        const directoryClient = yield getSystemClient((0, exports.getUrlsFromEndpoints)(client.config.endpointPool), client.config.directoryChainRid);
        const anchoringClient = yield (0, IccfProofTxMaterialBuilder_1.getAnchoringClient)(directoryClient, client.config.blockchainRid);
        const systemAnchoringChainRidBuffer = yield getSystemAnchoringChain(directoryClient);
        const systemAnchoringChainBridString = systemAnchoringChainRidBuffer.toString("hex");
        return { anchoringClient, systemAnchoringChainBridString };
    });
}
function getSystemAnchoringTransaction(dappClientEndpointPool, anchoredTxRid, anchoringClient, systemAnchoringChainRid, systemAnchoringStatusPolling, merkleHashVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const systemAnchoringChainClient = yield getSystemClient((0, exports.getUrlsFromEndpoints)(dappClientEndpointPool), systemAnchoringChainRid);
        const clusterAnchoringProof = yield anchoringClient.getConfirmationProof(anchoredTxRid);
        const clusterBlockRid = (0, utils_1.calculateBlockRID)(clusterAnchoringProof, merkleHashVersion);
        const systemAnchoringTransactionConfirmation = yield (0, utils_1.awaitGetAnchoringTransactionForBlockRid)(systemAnchoringChainClient, (0, formatter_1.toBuffer)(anchoringClient.config.blockchainRid), clusterBlockRid, systemAnchoringStatusPolling);
        const systemAnchoringTransactionValidation = anchoringTransaction_1.AnchoringTransactionSchema.safeParse(systemAnchoringTransactionConfirmation);
        if (!systemAnchoringTransactionValidation.success) {
            return null;
        }
        return systemAnchoringTransactionValidation.data;
    });
}
/**
 * Should be used to configure the `IClient` `ClientConfig` (config) properties
 * `dappStatusPolling`, `clusterAnchoringStatusPolling` and `systemAnchoringStatusPolling` with
 * the corresponding status polling configuration `interval` and `status`.
 * If the values are not provided, they do default to `500` for `interval` and `20` for `count`
 *
 * @param statusPolling - An optional partial configuration object, that can set the status polling interval and count properties
 * @returns - Returns a complete `StatusPolling` configuration object, with default values for any missing properties
 * of the provided partial configuration
 */
function setStatusPolling(statusPolling) {
    var _a, _b;
    return {
        interval: (_a = statusPolling === null || statusPolling === void 0 ? void 0 : statusPolling.interval) !== null && _a !== void 0 ? _a : 500,
        count: (_b = statusPolling === null || statusPolling === void 0 ? void 0 : statusPolling.count) !== null && _b !== void 0 ? _b : 20,
    };
}
function setRetryTransactionPolling(statusPolling) {
    var _a, _b;
    return {
        interval: (_a = statusPolling === null || statusPolling === void 0 ? void 0 : statusPolling.interval) !== null && _a !== void 0 ? _a : 500,
        count: (_b = statusPolling === null || statusPolling === void 0 ? void 0 : statusPolling.count) !== null && _b !== void 0 ? _b : 3,
    };
}
function linkPromiEvents(event1, event2) {
    const transactionEvents = Object.values(enums_1.TransactionEvent).filter((event) => typeof event === "string");
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const forwardEvent = (eventName) => (receipt) => event2.emit(eventName, receipt);
    for (const eventName of transactionEvents) {
        event1.on(eventName, forwardEvent(eventName));
    }
}
/**
 * @param error response error
 * @param statusCode response status code
 * @param responseObject the responsebody from the server
 * @param callback the callback function to propagate the error and response back to the caller
 */
function handleGetResponse(error, statusCode, responseObject, callback) {
    try {
        const responseObjectPrintable = convertToPrintable(responseObject);
        logger.debug(`error: ${error}, status code: ${statusCode}, response body: ${responseObjectPrintable}`);
        if (error) {
            return callback(error, null);
        }
        if (statusCode !== 200) {
            return callback(new errors_1.UnexpectedStatusError(statusCode !== null && statusCode !== void 0 ? statusCode : 400, responseObjectPrintable), null);
        }
        return callback(null, responseObject);
    }
    catch (error) {
        callback(error, null);
        logger.error(`client.handleGetResponse(): Failed to call the callback function. ${error}`);
    }
}
/**
 * @param error response error
 * @param statusCode response status code
 * @param responseObject the responsebody from the server
 * @param callback the callback function to propagate the error and response back to the caller
 */
function handlePostResponse(error, statusCode, responseObject, callback) {
    var _a;
    const responseObjectPrintable = convertToPrintable(responseObject);
    logger.debug(`error: ${error}, status code: ${statusCode}, response body: ${responseObjectPrintable}`);
    try {
        if (error) {
            logger.error(`In client post(). ${error}`);
            callback(error, null);
        }
        else if (!statusCode || !(0, http_utils_1.isSuccessfulStatusCode)(statusCode)) {
            let errorMessage = `Unexpected status code from server. Code: ${statusCode}.`;
            const errorMessageInResponseBody = !!responseObject && typeof responseObject === "object" && "error" in responseObject
                ? (_a = responseObject.error) === null || _a === void 0 ? void 0 : _a.toString()
                : "";
            if (responseObjectPrintable) {
                errorMessage += ` Message: ${responseObjectPrintable}.`;
            }
            logger.error(errorMessage);
            callback(new errors_1.UnexpectedStatusError(statusCode !== null && statusCode !== void 0 ? statusCode : 400, errorMessageInResponseBody || responseObjectPrintable), responseObject);
        }
        else {
            logger.info(`Calling responseCallback with responseObject: ${responseObjectPrintable}`);
            callback(null, responseObject);
        }
    }
    catch (error) {
        logger.error(`client.handlePostResponse(): Failed to call callback function ${error}`);
    }
}
function getBlockchainRidFromIid(_a) {
    return __awaiter(this, arguments, void 0, function* ({ endpointPool, chainId, failOverConfig = {}, nodeManager, connectTimeout, responseTimeout, }) {
        var _b;
        const mergedFailOverConfig = Object.assign(Object.assign({}, exports.defaultFailoverConfig), failOverConfig);
        const config = {
            endpointPool,
            nodeManager,
            dappStatusPolling: setStatusPolling(),
            clusterAnchoringStatusPolling: setStatusPolling(),
            systemAnchoringStatusPolling: setStatusPolling(),
            retryTransactionPolling: setRetryTransactionPolling(),
            failoverStrategy: mergedFailOverConfig.strategy,
            attemptsPerEndpoint: mergedFailOverConfig.attemptsPerEndpoint,
            attemptInterval: mergedFailOverConfig.attemptInterval,
            unreachableDuration: mergedFailOverConfig.unreachableDuration,
            merkleHashVersion: constants_1.MERKLE_HASH_VERSIONS.UNSET,
            connectTimeout,
            responseTimeout,
        };
        const { error, statusCode, rspBody } = yield (0, requestWithFailoverStrategy_1.requestWithFailoverStrategy)(enums_1.Method.GET, `/brid/iid_${chainId}`, config, undefined, false, (_b = config.connectTimeout) !== null && _b !== void 0 ? _b : config.responseTimeout);
        const blockchainRid = (0, requests_1.isString)(rspBody);
        if (!blockchainRid) {
            throw error;
        }
        if (error) {
            throw new errors_1.GetBridFromChainException(chainId, error.message);
        }
        else if (statusCode !== 200) {
            throw new errors_1.GetBridFromChainException(chainId, blockchainRid);
        }
        return blockchainRid;
    });
}
const sleep = (ms) => new Promise(r => setTimeout(r, ms));
exports.sleep = sleep;
function convertToPrintable(responseObject) {
    if (typeof responseObject === "bigint") {
        return `${responseObject}n`;
    }
    else if (typeof responseObject === "object") {
        return JSON.stringify(responseObject, (key, value) => typeof value === "bigint" ? `${value}n` : value);
    }
    else {
        return String(responseObject);
    }
}
//# sourceMappingURL=utils.js.map